import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, catchError, throwError } from "rxjs";
import { AuthenticationService } from "../services/authentication.service";
import { MsalAuthenticationService } from "@shared/services/msal-authentication.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private msalAuthenticationService: MsalAuthenticationService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        if (err.status === 500 || err.status === 403) {
          const error = err.error.message || err.statusText;
          return throwError(() => new Error(error));
        } else if (err.status === 401) {
          if (!this.msalAuthenticationService.isAdvisorSsoEntry()) {
            this.authenticationService.logout();
          }
        }
        return throwError(() => err);
      })
    );
  }
}
